var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintCheekL = function SvgPaintCheekL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 36,
    viewBox: "0 0 0.84 1.06",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.33.09c.31-.09.51.17.4.49C.68.73.57.91.47.98.36 1.05.1.76.08.53.06.31.13.15.33.09z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.32.7C.54.51.43.39.32.52.29.43.04.43.32.7z",
    fill: "#000"
  })));
};

export default SvgPaintCheekL;